'use strict';

export default class CodeController {

  /*@ngInject*/
  constructor($http, $state) {
    this.$http = $http;
    this.$state = $state;
  }

  $onInit() {
    this.getConfs();
  }

  getConfs() {
    this.$http.get('/api/AppConfs', {params: {type: 1}}).then(response => {
      this.confs = response.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete('api/AppConfs/' + id).then(response => {
        this.getConfs();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/appconfs/code/code.controller.js